/**
 * Format a date for display without shifting calendar dates across timezones.
 *
 * Deadlines are stored as calendar dates ("2026-10-02"). JavaScript parses a
 * date-only string as UTC midnight, so formatting it in the browser's local
 * timezone moves it back a day anywhere west of UTC — every user in the
 * Americas saw a project due a day earlier than it actually was.
 *
 * A date-only value is formatted as the calendar date it names; a full
 * timestamp is formatted as an instant in the viewer's timezone.
 */
export function formatCalendarDate(
  value: string | number | Date | null | undefined,
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' },
): string {
  if (value === null || value === undefined || value === '') return '';
  const text = typeof value === 'string' ? value.trim() : value;
  const isDateOnly = typeof text === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(text);
  const date = text instanceof Date ? text : new Date(text as string | number);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, isDateOnly ? { ...options, timeZone: 'UTC' } : options);
}
